module.exports = __webpack_public_path__ + "static/02-aa18b1065d69c1a65705892db6fd43b5.jpg";